import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Button, Grid, Divider, Segment, Header, Input } from 'semantic-ui-react';
import { getDetailInpatientClaimBySysAdmin, getClaimOptions } from '../../../actions'
import FormsInputsText from '../../../component/forms/inputs/text/forms_inputs_text';
import FormsInputDate from '../../../component/forms/inputs/date/index';
import FormsInputDropdown from '../../../component/forms/inputs/dropdown/index';
import FormsInputsTime from '../../../component/forms/inputs/time/index';

const yesNoOptions = [
    { text: 'Yes', value: 'Y' },
    { text: 'No', value: 'N' }
];

class InpatientView extends React.Component {

    componentDidMount() {

        if (this.props.user.accessToken) {

            // Get user ID
            const queryString = new URLSearchParams(this.props.history.location.search);
            const _id = queryString.get("_id");

            // Get Inpatient Detail
            this.props.getDetailInpatientClaimBySysAdmin(this.props.user.accessToken, { _id });

            // Get Inpatient Detail
            this.props.getDetailInpatientClaimBySysAdmin(this.props.user.accessToken, { _id });
        }
    }

    render() {

        const claimData = this.props.claims.detailInpatientData;
        const loading = this.props.claims.detailInpatientLoading;
        const isAdminOperation = false;

        if (loading) return "Loading";
        if (!claimData) return "Data Not Found";

        return (
            <Formik
                initialValues={{
                    _id: claimData._id,
                    transactionNo: claimData.transactionNo,
                    claimStatus: claimData.claimStatus,
                    companyName: claimData.detailCompany ? claimData.detailCompany.name : "",
                    claimantId: claimData.claimantId,
                    admissionDate: moment(claimData.admissionDate, 'D/M/YYYY'),
                    dischargeDate: moment(claimData.dischargeDate, 'D/M/YYYY'),
                    providerName: claimData.providerName,
                    reasonForTreatment: claimData.reasonForTreatment,
                    symptoms: claimData.symptoms,
                    symptomsStartDate: moment(claimData.symptomsStartDate, 'D/M/YYYY'),
                    nameOfOperation: claimData.nameOfOperation,
                    currency: claimData.currency,
                    amount: claimData.amount,
                    empSubRemarks: claimData.empSubRemarks,
                    accidentRelated: claimData.accidentRelated || 'N',
                    accidentDate: (claimData.accidentDateTime) ? moment(claimData.accidentDateTime, 'D/M/YYYY') : moment(),
                    accidentTime: (claimData.accidentDateTime) ? moment(claimData.accidentDateTime, 'D/MM/YYYY HH:mm') : moment(),
                    placeOfAccident: claimData.placeOfAccident || '',
                    workRelated: claimData.workRelated || 'N',
                    accidentDetails: claimData.accidentDetails || '',
                    accidentClaimableFromCompany: claimData.accidentClaimableFromCompany || 'N',
                    claimingFromOtherInsurer: claimData.claimingFromOtherInsurer || 'N',
                    claimingFromOtherInsurerName: claimData.claimingFromOtherInsurerName || '',
                }}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={this.props.onSubmit}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                        <Segment>
                            <Form>

                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        <Divider horizontal> <Header as='h3'>Hospitalisation Information</Header></Divider>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="transactionNo" label="Transaction No" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="claimStatus" label="Status" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="companyName" label="Company" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="claimantId" label="Claimant NRIC" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="admissionDate" component={FormsInputDate} label="Admission Date" secondaryLabel="" maxDate={moment()} disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="dischargeDate" component={FormsInputDate} label="Discharge Date" secondaryLabel="" minDate={values.admissionDate} maxDate={moment()} disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="providerName" label="Hospital" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field name="reasonForTreatment" label="Diagnosis / Medical Condition" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Field name="symptoms" label="Description of Symptoms" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="symptomsStartDate" label="Date the Symptoms Started" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field name="nameOfOperation" label="Name of Operation / Surgical Code" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="currency" label="Currency" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="amount" label="Amount" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="empSubRemarks" label="Remarks" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>

                                    <Grid.Column width={16} style={{ margin: "13px 0 0 0" }}>
                                        <Divider horizontal>
                                            Accident Information
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column>
                                        <Field
                                            name="accidentRelated"
                                            options={yesNoOptions}
                                            label="Is this claim for treatment of injury as a result of an accident?"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>

                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="accidentDate"
                                                    component={FormsInputDate}
                                                    label="Date of Accident"
                                                    secondaryLabel=""
                                                    maxDate={values.admissionDate}
                                                    disabled={!isAdminOperation}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="accidentTime"
                                                    label="Time of Accident"
                                                    component={FormsInputsTime}
                                                    secondaryLabel=""
                                                    disabled={!isAdminOperation}
                                                    minTime={moment().startOf('day')}
                                                    maxTime={moment()}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="placeOfAccident"
                                                    label="Place of Accident"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={!isAdminOperation}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="workRelated"
                                                    options={yesNoOptions}
                                                    label="Is it work related?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                    disabled={!isAdminOperation}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentDetails"
                                                    label="Give details of how the injury was caused by the accident. (Please enclose a copy of the police report, if any)"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={!isAdminOperation}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y")
                                        &&
                                        (values.workRelated === "Y")
                                        &&
                                        (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentClaimableFromCompany"
                                                    options={yesNoOptions}
                                                    label="Are these medical expenses claimable under your company's work injury compensation act policy?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column width={16}>
                                        <Field
                                            name="claimingFromOtherInsurer"
                                            options={yesNoOptions}
                                            label="Have you claimed or do you intend to claim from any insurer, other employer or any other parties for reimbursement of your medical bills? If yes, please state the party that you are claiming from and submit a copy of the settlement letter or payment voucher from the other party."
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.claimingFromOtherInsurer === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="claimingFromOtherInsurerName"
                                                    label="Name of the party that you are claiming from"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={!isAdminOperation}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                </Grid>

                                <br />
                                <br />
                            </Form>
                        </Segment>
                    )}
            >
            </Formik>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        claims: state.systemAdminClaims,
        claimOptions: state.claimOptions,
    };
}

export default connect(mapStateToProps, {
    getDetailInpatientClaimBySysAdmin,
    getClaimOptions,
})(withRouter(InpatientView))